module.exports = __webpack_public_path__ + "media/images/hand-holding-usd-solid-eaec45584125e172070946df7b4a72c3.svg";